import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, RouterModule, Routes } from '@angular/router';
import {Observable} from 'rxjs/Rx';
import { config } from '../../../providers/config';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  user: any = FormGroup;
  model: any = {
    username:null,
    password:null
  };
  loginError:boolean = false;
  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router:Router
  ) { }

  ngOnInit() {
    this.user = this.fb.group({
      username: ['', Validators.compose([Validators.required])],
      password: ['', Validators.compose([Validators.required])],
    });
  }
  
  login() {
    this.authService.login(this.model).subscribe(res=> {
       this.getUserInfo();
    },
    error => {
      this.loginError = true;
    });

  }

  getUserInfo() {
      const userId = localStorage.getItem('user_id');
      this.authService.getUserRole(userId).subscribe(res=> {
        if(res['is_doctor'] || res['is_superuser'] || res['is_clinic_admin']) {
          const token = localStorage.getItem('token');
          localStorage.clear();
          window.location.href = `${config.provider_url}/#/redirect/${token}`; 
        } else {
          this.router.navigate(['/home']);
        }
    },
    error => {
    });
  }

}



// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/components/login/login.component.ts